// frontend/src/data/blogPosts.js
//
// Post bodies live in blog-posts.json so that scripts/prerender.js (plain Node)
// and React read the same data without a module-format disagreement. See the
// note at the top of seoMeta.js — making this file CommonJS to satisfy Node
// blanked the site, because webpack still treated it as an ES module.
//
// Swap this for Markdown or CMS calls later; consumers only need `blogPosts`.

import posts from './blog-posts.json'

export const blogPosts = posts
